import "./bootstrap";
import "../css/app.css";

import { createApp, h, DefineComponent, reactive, ref } from "vue";
import { createInertiaApp } from "@inertiajs/vue3";
import { resolvePageComponent } from "laravel-vite-plugin/inertia-helpers";
import { ZiggyVue } from "../../vendor/tightenco/ziggy";
import VueCookies from "vue-cookies";
import { InertiaLocalVisit, findLocalPage, type LocalPages } from "@madnow/inertia-local-visit";
import { createPinia } from "pinia";
import { router } from '@inertiajs/vue3'
import Vue3Lottie from "vue3-lottie";
import * as Sentry from "@sentry/vue";

const localPages: LocalPages = [
  {
    url: /^\/test\/section\/\d+\/question\/\d+$/,
    component: "TestSection/Questions",
  },
];

const appName = import.meta.env.VITE_APP_NAME || "Laravel";

void createInertiaApp({
  title: (title) => `${title} - ${appName}`,
  resolve: (name) =>
    resolvePageComponent(
      `./Pages/${name}.vue`,
      import.meta.glob<DefineComponent>("./Pages/**/*.vue"),
    ),
  setup({ el, App, props, plugin }) {
    // @ts-expect-error fails to recognize dataset
    let initialPage = JSON.parse(el.dataset.page);
    if (initialPage.component === "not-found") {
      const matched = findLocalPage(window.location.pathname, localPages);

      if (matched) {
        initialPage = {
          url: window.location.pathname,
          component: matched.component,
        };
      }
    }

    props.initialPage = initialPage;

    const myApp = createApp({ render: () => h(App, props) });
    const pinia = createPinia();

    // store global loading state to be used in pages
    myApp.config.globalProperties.$loading = ref<boolean>(false);

    router.on('start', () => myApp.config.globalProperties.$loading.value = true);
    router.on('finish', () => myApp.config.globalProperties.$loading.value = false);

    myApp
      .use(plugin)
      .use(ZiggyVue)
      .use(VueCookies)
      .use(InertiaLocalVisit, { localPages })
      .use(pinia)
      .use(Vue3Lottie)
      .mount(el);


    Sentry.init({
      app: myApp,
      dsn: "https://6ce4557e8eb0273b009755f46717da35@o4507794515820544.ingest.de.sentry.io/4508286455119952",
      integrations: [
        //Sentry.browserTracingIntegration({ router }),
        Sentry.replayIntegration(),
      ],
      // Tracing
      tracesSampleRate: 1.0, //  Capture 100% of the transactions
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
      // Session Replay
      replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
      replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    });
  },
  progress: {
    color: "#4B5563",
  },
});
